import { AssessmentSubmissionNodeType } from "types/graphql-schema";

import { UseLabelType } from "@apps/use-label/use-label";

export const submissionLabels = (label: UseLabelType) => ({
  [AssessmentSubmissionNodeType.PeerNominations]: "Peer Nominations",
  [AssessmentSubmissionNodeType.SelfAssessment]: `Self ${label("review", {
    capitalize: true,
  })}`,
  [AssessmentSubmissionNodeType.ManagerAssessment]: `Downward ${label(
    "review",
    {
      capitalize: true,
    },
  )}`,
  [AssessmentSubmissionNodeType.PeerAssessment]: `Peer ${label("review", {
    capitalize: true,
    pluralize: true,
  })}`,
  [AssessmentSubmissionNodeType.UpwardAssessment]: `Upward ${label("review", {
    capitalize: true,
    pluralize: true,
  })}`,
  [AssessmentSubmissionNodeType.Calibration]: "Calibration",
  [AssessmentSubmissionNodeType.Delivery]: "Share with Subject",
});

// we only want to warn the manager when the self assessment or
// peer assessment/nominations are incomplete
export const filterManagerAndCompletedSubmissions = (
  submission: {
    type: AssessmentSubmissionNodeType;
    completeCount: number;
    pendingCount: number;
  } | null,
) =>
  submission &&
  ((submission.type === AssessmentSubmissionNodeType.SelfAssessment &&
    submission.pendingCount > 0) ||
    (submission.type === AssessmentSubmissionNodeType.PeerNominations &&
      submission.completeCount === 0) ||
    (submission.type === AssessmentSubmissionNodeType.PeerAssessment &&
      submission.pendingCount > 0));
